import ValidationBase, { ValidateUtil, ValidationType } from "./ValidationBase";

export default class FormFieldBase {
    Value: any;
    Error: string;
    Mandatory: boolean;
    Validations: ValidationBase[];

    ValidateFieldCustom: (value: any) => string;
    ChangeInputFieldCustom: (value: any) => void;

    constructor(Value: any, Validations: ValidationBase[], callBackCustomValidation?: (Value: any) => string, callBackChangeInput?: (Value: any) => void) {
        this.Value = Value;
        this.Error = "";
        this.Validations = Validations;
        this.Mandatory = false;

        if (callBackCustomValidation)
            this.ValidateFieldCustom = callBackCustomValidation;
        else
            this.ValidateFieldCustom = () => "";

        if (callBackChangeInput)
            this.ChangeInputFieldCustom = callBackChangeInput;
        else
            this.ChangeInputFieldCustom = () => "";

        if (this.Validations != null && this.Validations.length > 0) {
            for (let index = 0; index < this.Validations.length; index++) {
                const element = this.Validations[index];
                if (element.Validation === ValidationType.OBRIGATORIO) {
                    this.Mandatory = true;
                }
            }
        }
    }


    HasError(): boolean {

        if (this.Validations === null || this.Validations.length === 0) {
            return false;
        }

        return !(this.Error === "");
    }

    ValidateField(): string {
        if (this.Validations != null && this.Validations.length > 0) {
            for (let index = 0; index < this.Validations.length; index++) {
                const element = this.Validations[index];
                const errorMessage = ValidateUtil(element.Validation, this.Value, (value: any) => this.ValidateFieldCustom(value))

                if (errorMessage !== null && errorMessage !== "") {
                    if (element.Message !== "") {
                        this.Error = element.Message
                    } else {
                        this.Error = errorMessage;
                    }
                    break;
                } else {
                    this.Error = ""
                }
            }
        }

        return this.Error;
    }

    InputChange(Value: any): void {
        this.ChangeInputFieldCustom(Value);
    }
}